'use client';
import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';

function SocialBarAds() {
  const banner = useRef<HTMLDivElement>(null);

  const atOptions = {
    key: 'dbff04304f41f2a2f1de24ed2ddfed80',
    format: 'iframe',
    height: 50,
    width: 320,
    params: {},
  };
  useEffect(() => {
    if (banner.current && !banner.current.firstChild && window.innerWidth > 768) {
      const conf = document.createElement('script');
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = `//pl25607672.profitableratecpm.com/ee/76/00/ee7600670e02fed7ec71d0ef9e2bd4ef.js`;
      conf.innerHTML = `atOptions = ${JSON.stringify(atOptions)}`;

      banner.current.append(conf);
      banner.current.append(script);
    }
    console.log(window.innerWidth);
  }, [banner]);

  return (
    <div className="">
      <div
        className="mx-2 my-5 justify-center items-center text-white text-center"
        ref={banner}
      ></div>
      <Script
        type="text/javascript"
        src="//pl25607672.profitablecpmrate.com/ee/76/00/ee7600670e02fed7ec71d0ef9e2bd4ef.js"
      />
    </div>
  );
}

export default SocialBarAds;
